import React from 'react';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import { setCookie } from '../../../Utils';
import { PsBeaconButton } from '../BeaconRegister';

const EnvSwitch = ({ state }) => {
    const [currentEnv, setCurrentEnv] = React.useState(state?.cookieEnv);
    const [currentColorEnv, setCurrentColorEnv] = React.useState(state?.colorCookieEnv);
    const [currentEnvLabel, setEnvLabel] = React.useState('live');

    React.useEffect(() => {
        if (currentEnv === 'live') {
            setEnvLabel('LIVE');
        }

        if (currentEnv === 'alt') {
            setEnvLabel('STAGE B');
        }

        if (currentEnv === 'alt2') {
            setEnvLabel('STAGE C');
        }

        if (currentEnv === 'alt3') {
            setEnvLabel('STAGE D');
        }
    }, [currentEnv]);

    const setEnvCookie = (cookie) => {
        if (cookie === 'live') {
            setCookie('ii-adv-ui-traffic', 'live', -1, state?.isCustomerWebView);
            setCookie('adv-svc-traffic', 'live', -1, state?.isCustomerWebView);
            setCurrentEnv('live');
            setCurrentColorEnv('live');
        } else {
            setCookie('ii-adv-ui-traffic', cookie, 1, state?.isCustomerWebView);
            setCookie('adv-svc-traffic', cookie, 1, state?.isCustomerWebView);
            setCurrentEnv(cookie);
            setCurrentColorEnv(cookie);
        }
    };

    //if adv-svc-stage cookie doesn't match, enable all buttons

    return (
        <Box
            sx={{
                backgroundColor: 'rgba(51, 51, 51, .05)',
                position: 'fixed',
                top: 0,
                marginTop: '136px',
                right: 0,
            }}
            id="env-button-container">
            <Box sx={{ padding: '10px' }}>
                <Box sx={{ paddingBottom: '4px' }}>
                    <PsBeaconButton
                        id="cookie-env-switch-live"
                        variant="secondary"
                        onClick={() => setEnvCookie('live')}
                        disabled={currentEnv === 'live' && currentColorEnv === 'live'}
                        scale="normal">
                        Switch Live
                    </PsBeaconButton>
                </Box>
                <Box sx={{ paddingBottom: '4px' }}>
                    <PsBeaconButton
                        id="cookie-env-switch-alt"
                        variant="secondary"
                        onClick={() => setEnvCookie('alt')}
                        disabled={currentEnv === 'alt' && currentColorEnv === 'alt'}
                        scale="normal">
                        Switch Alt
                    </PsBeaconButton>
                </Box>
                <Box sx={{ paddingBottom: '4px' }}>
                    <PsBeaconButton
                        id="cookie-env-switch-alt2"
                        variant="secondary"
                        onClick={() => setEnvCookie('alt2')}
                        disabled={currentEnv === 'alt2' && currentColorEnv === 'alt2'}
                        scale="normal">
                        Switch Alt2
                    </PsBeaconButton>
                </Box>
                <Box sx={{ paddingBottom: '4px' }}>
                    <PsBeaconButton
                        id="cookie-env-switch-alt2"
                        variant="secondary"
                        onClick={() => setEnvCookie('alt3')}
                        disabled={currentEnv === 'alt3' && currentColorEnv === 'alt3'}
                        scale="normal">
                        Switch Alt3
                    </PsBeaconButton>
                </Box>
                <Box sx={{ paddingTop: '4px' }}>
                    Viewing: <strong>{currentEnvLabel}</strong>
                </Box>
            </Box>
        </Box>
    );
};

export default EnvSwitch;
